"use client"

import type { ReactNode } from "react"

import toast from "react-hot-toast"

import { forgotPasswordDto } from "#app/(frontend)/[locale]/(user)/(auth)/forgot-password/forgotPassword.dto"
import { RHFForm } from "#components/form/rhfFormContext"
import { useValidatedForm } from "#components/form/useValidatedForm"
import { CONTACT_EMAIL } from "#environment/constants"
import { api } from "#lib/http-client"
import { useTranslation } from "#modules/localization/translations.client"

export function ForgotPasswordForm({ children }: { children: ReactNode }) {
  const { t } = useTranslation("forms", "page/forgotPassword", "common")

  const formMethods = useValidatedForm({
    validation: forgotPasswordDto(t),
    onSubmit: async data => {
      toast.loading(t("page/forgotPassword:processing.loading"))

      try {
        await api().post("/auth/forgot-password", data)

        formMethods.reset()
        toast.dismiss()
        toast.success(t("page/forgotPassword:processing.success"))
      } catch (e) {
        toast.dismiss()
        toast.error(t("common:loading.genericError", { CONTACT_EMAIL }))
      }
    },
  })

  return <RHFForm formMethods={formMethods}>{children}</RHFForm>
}
